import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupProductsList } from '@shared/api/lib/group/group';
import {
  GroupProductsListParams,
  PaginatedGroupProductListList,
} from '@shared/api/types';

/**
 * Paginated PCF products across the parent's selected child organizations.
 * No date filter — products are not period-bound.
 */
export const useGetGroupProducts = (params?: GroupProductsListParams) =>
  useGroupProductsList<PaginatedGroupProductListList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });
